import ApiClient from './ApiClient'

export default class IdCheckServices {

  constructor() {
    this.apiClient = new ApiClient()
  }

  generateVerificationSession() {
    return this.apiClient.createAuthed().get('id-check')
  }

  getIdCheckStatus() {
    return this.apiClient.createAuthed().get('id-check/users-status')
  }

}